__turbopack_context__.v({
  "aboutWrapper": "SecondScreenInfra-module-scss-module__euy60a__aboutWrapper",
  "bottomContent": "SecondScreenInfra-module-scss-module__euy60a__bottomContent",
  "button": "SecondScreenInfra-module-scss-module__euy60a__button",
  "image": "SecondScreenInfra-module-scss-module__euy60a__image",
  "svgLineWrapper": "SecondScreenInfra-module-scss-module__euy60a__svgLineWrapper",
  "title": "SecondScreenInfra-module-scss-module__euy60a__title",
  "topTextContent": "SecondScreenInfra-module-scss-module__euy60a__topTextContent",
  "wrapper": "SecondScreenInfra-module-scss-module__euy60a__wrapper",
});
